import { connect } from 'react-redux';
import React, { Component } from 'react';
import image1 from '../../assets/img/galeblogo.jpg'
import Card from '../Card/Card';
import classnames from 'classnames';
import TextFieldGroup from '../common/TextFieldGroup';
import axios from 'axios';
import Swal from 'sweetalert2';
const div1 = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "inherit",
  padding: "3px"
}

const div2 = {
  width: "80%",
  height: "80%",
  background: "#fff",
  boxShadow: "15px 15px 25px #ccc",
  borderRadius: "15px"
}

const centerText = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  }
})
class admissionApplication extends Component {
  constructor(props) {
    super(props)
    this.state = {
      position: '',
      firstAndLastName: '',
      birthDate: '',
      address: '',
      city: '',
      country: '',
      phoneNumber: '',
      email: '',
      education: '',
      qualificationLevel: '',
      possibleFirstDayOnJob: '',
      expectedPay: '',
      expectedPayAfterTraining: '',
      expectation: '',
      whatYaThinkBoutGaleb: '',
      recomendation: '',
      file: null,
      width: window.innerWidth
    }
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeFile = this.onChangeFile.bind(this);
  }

  updateDimensions() {
    this.setState({ width: window.innerWidth });
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }

  onSubmit(e) {
    e.preventDefault();
    // This is ugly, but works :D  
    const { position, firstAndLastName, birthDate, address, city, country, phoneNumber, email, education, qualificationLevel, possibleFirstDayOnJob, expectedPay, expectedPayAfterTraining, expectation, whatYaThinkBoutGaleb, recomendation } = this.state;
    for (let i = 0; i < 15; i++) {
      const dataArray = [position, firstAndLastName, birthDate, address, city, country, phoneNumber, email, education, qualificationLevel, possibleFirstDayOnJob, expectedPay, expectedPayAfterTraining, expectation, whatYaThinkBoutGaleb]
      if (dataArray[i] === '') {
        Toast.fire({
          icon: 'error',
          title: 'Neki od neophodnih podataka nije unet!'
        })
        return;
      }
    }
/*
    if (this.state.file === null) {
      Toast.fire({
        icon: 'error',
        title: 'Nije priložen CV!'
      })
      return;
    }
*/
    const formData = new FormData();
    //for (let i = 0; i < this.state.file.length; i++) {
      if(this.state.file != null){
      const fileNo = `file-${0}`
      const fileValue = this.state.file[0]
      const fileName = this.state.file[0].name
      formData.append(
        fileNo,
        fileValue,
        fileName,
      );
      }
      
      formData.append('position', position)
      formData.append('firstAndLastName', firstAndLastName)
      formData.append('birthDate', birthDate)
      formData.append('address', address)
      formData.append('city', city)
      formData.append('country', country)
      formData.append('phoneNumber', phoneNumber)
      formData.append('email', email)
      formData.append('education', education)
      formData.append('qualificationLevel', qualificationLevel)
      formData.append('possibleFirstDayOnJob', possibleFirstDayOnJob)
      formData.append('expectedPay', expectedPay)
      formData.append('expectedPayAfterTraining', expectedPayAfterTraining)
      formData.append('expectation', expectation)
      formData.append('whatYaThinkBoutGaleb', whatYaThinkBoutGaleb)
      formData.append('recomendation', recomendation)
    //}

    for (const value of formData.values()) {
      console.log(value);
    }
    console.log(formData)
    axios.postForm(`/api/adminApi/applyForSomething/`, formData, { headers: { 'content-type': 'multipart/form-data' } })
      .then(resp => {
        Toast.fire({
          icon: 'success',
          title: 'Vaši podaci su uspešno poslati!'
        })
      })
      .catch(err => {
        console.log(err)
        Toast.fire({
          icon: 'error',
          title: 'Problem! ' + err?.response?.data
        })
      })
  }

  onChangeFile(e) {
    this.setState({ file: e.target.files });
  }

  handleFileUpload = event => {
    console.log(event.target.files.name);
  };

  onChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    let condDiv;
    this.state.width < 990 ? (condDiv = 'col-md-12') : (condDiv = 'col-md-8')
    return (
      <div className="Content">
        <div style={div1} className={condDiv}>
          <div style={div2}>
            <div style={{ textAlign: "center", margin: "24px 50px 12px" }}>
              <div style={{ padding: "16px 0", textAlign: "left" }}>
                <div style={centerText}><img alt='galebLogo' src={image1} width={'180px'} /></div>
                <br /><br />
                <div className='col-md-12'>
                  <Card
                    title="Prijavni upitnik"
                    content={
                      <div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Pozicija za koju konkurišete: *"
                            placeholder="Odgovor"
                            name="position"
                            value={this.state.position}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Ime i prezime: *"
                            placeholder="Odgovor"
                            name="firstAndLastName"
                            value={this.state.firstAndLastName}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Datum rođenja: *"
                            type="date"
                            placeholder="Odgovor"
                            name="birthDate"
                            value={this.state.birthDate}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Adresa prebivališta: *"
                            placeholder="Odgovor"
                            name="address"
                            value={this.state.address}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Grad prebivališta: *"
                            placeholder="Odgovor"
                            name="city"
                            value={this.state.city}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Država prebivališta: *"
                            placeholder="Odgovor"
                            name="country"
                            value={this.state.country}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Broj telefona"
                            placeholder="Odgovor"
                            name="phoneNumber"
                            value={this.state.phoneNumber}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Email adresa: *"
                            placeholder="Odgovor"
                            name="email"
                            value={this.state.email}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Obrazovanje (vrsta stručne spreme): *"
                            placeholder="npr. diplomirani mašinski inženjer"
                            name="education"
                            value={this.state.education}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <label className="control-label">Stepen stručne spreme: *</label>
                          <select className={classnames('form-control')}
                            name="qualificationLevel"
                            value={this.state.qualificationLevel}
                            onChange={this.onChange}
                          >
                            <option value="">* Izaberite stepen</option>
                            <option value="I Osnovno obrazovanje"> I Osnovno obrazovanje</option>
                            <option value="II Stručno osposobljavanje">II Stručno osposobljavanje </option>
                            <option value="III Srednje obrazovanje">III Srednje obrazovanje </option>
                            <option value="IV Srednje obrazovanje">IV Srednje obrazovanje </option>
                            <option value="V Majstorsko i specijalističko obrazovanje"> V Majstorsko i specijalističko obrazovanje</option>
                            <option value="VI Osnovne akademske ili strukovne studije">VI Osnovne akademske ili strukovne studije </option>
                            <option value="VII Master ili specijalističke ili strukovne studije">VII Master ili specijalističke ili strukovne studije </option>
                          </select>
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Mogući datum stupanja na novo radno mesto: *"
                            type="date"
                            placeholder="Odgovor"
                            name="possibleFirstDayOnJob"
                            value={this.state.possibleFirstDayOnJob}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Očekivana plata na početku: *"
                            placeholder="Odgovor"
                            name="expectedPay"
                            value={this.state.expectedPay}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Očekivana plata nakon obuke: *"
                            placeholder="Odgovor"
                            name="expectedPayAfterTraining"
                            value={this.state.expectedPayAfterTraining}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Koja su Vaša očekivanja od kompanije i pozicije za koju konkurišete? *"
                            placeholder="Odgovor"
                            name="expectation"
                            value={this.state.expectation}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Koji je Vaš stav o kompaniji 'GALEB'? * "
                            placeholder="Odgovor"
                            name="whatYaThinkBoutGaleb"
                            value={this.state.whatYaThinkBoutGaleb}
                            onChange={this.onChange}
                          />
                        </div>
                        <div className="col-md-12">
                          <TextFieldGroup
                            label="Ukoliko neko može dati preporuku za Vas, molimo Vas da navedete ime, prezime i broj telefona te osobe:"
                            placeholder="Odgovor"
                            name="recomendation"
                            value={this.state.recomendation}
                            onChange={this.onChange}
                          />
                        </div>
                        <br />
                        <div style={centerText}>
                          Dodaj CV (u .prf formatu)
                        </div>
                        <br />
                        <div style={centerText}>
                          <div className="row">
                            <form className='justify-content-center'>
                              <input type="file" onChange={this.onChangeFile} accept=".pdf" name="file" />
                            </form>
                          </div>
                        </div>
                        <br />
                        <div style={centerText}>
                          <input
                            type="submit"
                            value="Pošalji"
                            onClick={this.onSubmit}
                            className="btn-fill col-md-3 pull-center btn btn-info"
                            style={{ margin: '3px' }}
                          />
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div >
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

export default connect(
  mapStateToProps,
)(admissionApplication);